import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Proforma } from '@app/models/proforma';
import * as ProformaActionTypes from '@app/modules/core/actions/proforma.actions';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import * as FileSaver from 'file-saver/FileSaver';

import * as ProformaActions from '@core/actions/proforma.actions';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class ProformaService {
  constructor(private http: HttpClient, private store: Store<any>) {}

  getSupplierFileInfo(FollowId) {
    const query = `?FollowId=${FollowId}`;
    return this.http.get<any>(`${API}proformas/supplierFileInfo${query}`);
  }

  supplierFileUpdate(FileId, status, followType) {
    return this.http.post<any>(`${API}proformas/supplierFileInfoUpdate`, {
      FileId,
      status,
      followType
    });
  }

  migrateProductShipment(data) {
    return this.http.post<any>(`${API}proformas/migrateProductShipment`, data);
  }

  upsertEnrichProducts(data) {
    const { productId } = data;
    return this.http.put<Proforma>(
      `${API}proformas/enrichProducts/${productId}`,
      data
    );
  }

  exportEnrichProducts(data: any) {
    const filename = 'enrichProducts';
    return this.http
      .get(`${API}proformas/downloadEnrich?data=${data}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, filename);
          this.store.dispatch(
            new ProformaActions.DownloadEnrichProductsSuccess()
          );
        },
        err => {
          this.store.dispatch(
            new ProformaActions.DownloadEnrichProductsFail(err)
          );
        }
      );
  }

  recalculate(ProformaId) {
    return this.http.get<Proforma[]>(
      `${API}proformas/recalculate?ProformaId=${ProformaId}`
    );
  }

  getDepartmentSheets() {
    return this.http.get<any>(`${API}proformas/departmentSheets`);
  }

  getN2Department() {
    return this.http.get<any>(`${API}proformas/n2department`);
  }

  getEnrichProducts(data: any) {
    const query =
      data && data.SupplierId
        ? `?SupplierId=${data.SupplierId}`
        : data && data.FollowId
        ? `?FollowId=${data.FollowId}`
        : '';
    return this.http.get<any>(`${API}proformas/providerSheets${query}`);
  }

  enrichProducts(data: any) {
    return this.http.post<any>(`${API}proformas/enrichProducts`, data);
  }

  get(FollowId, options?) {
    let query = '';

    if (FollowId) {
      query = `?FollowId=${FollowId}`;

      if (options) {
        Object.keys(options).forEach(key => {
          query = `${query}&${key}=${options[key]}`;
        });
      }
    }

    return this.http.get<Proforma[]>(`${API}proformas${query}`);
  }

  create(data) {
    return this.http.post<Proforma>(`${API}proformas`, data);
  }

  deleteProductProforma(pcsId) {
    return this.http.delete<Proforma>(`${API}proformas`);
  }

  updateOne(ProformaId, data) {
    return this.http.post<any>(`${API}proformas/updateOne/${ProformaId}`, data);
  }

  update(ProformaId, data) {
    return this.http.put<any>(`${API}proformas/${ProformaId}`, data);
  }

  generate(FollowId) {
    return this.http.post<Proforma[]>(`${API}proformas/initialize`, {
      FollowId
    });
  }

  addDelayProforma(data) {
    return this.http.post(`${API}proformas-delay/`, data);
  }

  updateGenerate(FollowId, options?) {
    console.log('options ->', options);
    return this.http.post<Proforma[]>(`${API}proformas/initializeUpdate`, {
      FollowId,
      options
    });
  }

  getProformasSummary(FollowId) {
    return this.http.get(`${API}proformas/summary?FollowId=${FollowId}`);
  }

  getAvailableProducts(ProformaId, data) {
    const {
      FollowId,
      factory,
      CountryId,
      businessUnit,
      DestinationCenterId,
      leadTime,
      PortId,
      ProviderId,
      ShipmentId
    } = data;

    let query = '';
    if (FollowId) {
      query += `FollowId=${FollowId}&`;
    }
    if (factory) {
      query += `factory=${factory}&`;
    }
    if (CountryId) {
      query += `CountryId=${CountryId}&`;
    }
    if (businessUnit) {
      query += `businessUnit=${businessUnit}&`;
    }
    if (DestinationCenterId) {
      query += `DestinationCenterId=${DestinationCenterId}&`;
    }
    if (leadTime) {
      query += `leadTime=${leadTime}&`;
    }
    if (PortId) {
      query += `PortId=${PortId}&`;
    }
    if (ShipmentId) {
      query += `ShipmentId=${ShipmentId}&`;
    }
    if (ProviderId) {
      query += `ProviderId=${ProviderId}`;
    }

    return this.http.get(`${API}proformas/${ProformaId}/products/new?${query}`);
  }

  getAvailableProductNewProforma(data) {
    return this.http.get(
      `${API}proformas/newProformaProduct?ProviderId=${
        data.ProviderId
      }&FollowgroupId=${data.FollowId}`
    );
  }

  newProformaProduct(shipmentId, selectedProductIds, providerId, udnCountry) {
    return this.http.post(`${API}proformas/newProformaProduct`, {
      shipmentId,
      selectedProductIds,
      providerId,
      udnCountry
    });
  }

  addProducts(ProformaId, ProductIds, FollowId, data) {
    return this.http.post(`${API}proformas/${ProformaId}/products`, {
      ProductIds,
      FollowId,
      ShipmentId: data.ShipmentId,
      businessUnit: data.businessUnit,
      CountryId: data.CountryId,
      ProviderId: data.ProviderId,
      proformaId: data.proformaId,
      fobType: data.fobType
    });
  }

  deleteProduct(ProformaId, ProductId, ShipmentId) {
    return this.http.delete(
      `${API}proformas/${ProformaId}/products/${ProductId}/shipment/${ShipmentId}`
    );
  }

  downloadDetailProformas(data) {
    return this.http
      .post(
        `${API}proformas/export-proformas-detail`,
        { FollowId: data },
        {
          responseType: 'blob',
          observe: 'response'
        }
      )
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Detalle proformas-${data}.xlsx`);
          this.store.dispatch(
            new ProformaActionTypes.ProformasDetailDownloabledSuccess()
          );
        },
        err => {
          this.store.dispatch(
            new ProformaActionTypes.ProformasDetailDownloabledFail(err)
          );
        }
      );
  }

  deleteAllProforma(ProformaId) {
    return this.http.delete(`${API}proformas/deleteAll?FollowId=${ProformaId}`);
  }

  search(conditions, FollowId) {
    const data = [...conditions, { key: 'FollowId', value: FollowId }];

    return this.http.post<any>(`${API}proformas/search`, data);
  }

  searchProduct(ProformaId, conditions) {
    // const data = [...conditions, { key: 'FollowId', value: ProformaId }];
    return this.http.post<any>(
      `${API}proformas/${ProformaId}/searchProduct`,
      conditions
    );
  }

  updateStatus(FollowId, data) {
    return this.http.put<Proforma>(`${API}proformas/${FollowId}/status`, data);
  }
}
